import { ApiClient } from "@/services/apiClient";
import { type OnlyPublicProperties } from "@/types";
import type { Filter } from "@/services/collection";
import { type CollectionMetadata, type CollectionStatistics } from "@/services/collection";

export const fetchCollectionStatistics = async (filter: OnlyPublicProperties<Filter.Filter>): Promise<CollectionStatistics> => {
  const url = "api/collection/statistics";
  const params = filter.createApiParams();
  return ApiClient.get<CollectionStatistics>(url, params).then((response) => response.data);
};

export const fetchCollectionMetadata = async (filter: OnlyPublicProperties<Filter.Filter>): Promise<CollectionMetadata> => {
  const url = "api/collection/metadata";
  const params = filter.createApiParams();
  return ApiClient.get<CollectionMetadata>(url, params).then((response) => response.data);
};
